import type { ReactNode } from "react";
import { Alert } from "@mantine/core";

interface ErrorStateProps {
    children: ReactNode;
    /** Set for a block that stands on its own, such as a page that failed to load. */
    title?: string;
}

/**
 * Something failed. One red alert, announced to screen readers, so every error
 * looks and sounds the same.
 */
export function ErrorState({ children, title }: ErrorStateProps) {
    return (
        <Alert color="red" radius="md" role="alert" title={title}>
            {children}
        </Alert>
    );
}
